<ng-template #loading>
    <app-mat-spinner-overlay text="Vent litt..."></app-mat-spinner-overlay>
</ng-template>

<div *ngIf="!isLoading; else loading">

    <form [formGroup]="caseForm">

        <h1>Klageskjema for {{getComplainerTypeText()}}</h1>

        <p *ngIf="getLabelValue('FormIntroduction')" [innerHtml]="getLabelValue('FormIntroduction') | safe: 'html'"></p>

        <mat-stepper matVerticalStepperScroller orientation="vertical" [linear]="true" #stepper>

            <mat-step [stepControl]="caseForm.controls.onBehalfOfForm">

                <ng-template matStepLabel>Hvem klager du på vegne av?</ng-template>

                <div formGroupName="onBehalfOfForm" class="form-container flex-column flex-gap-20">

                    <mat-radio-group class="flex-column" formControlName="onBehalfOf">
                        <mat-radio-button [value]="1">Jeg klager på egne vegne</mat-radio-button>
                        <mat-radio-button [value]="2">Jeg klager på vegne av en annen</mat-radio-button>
                        <mat-radio-button [value]="3">Jeg er advokat/rettshjelper e.l., og representerer en klient
                        </mat-radio-button>
                        <mat-radio-button [disabled]="complaintType < 2" [value]="4">Jeg klager i næringsvirksomhet
                        </mat-radio-button>
                    </mat-radio-group>

                    <div class="bank-debt-message" *ngIf="complaintType < 2"
                        [innerHtml]="getLabelValue('FormBankDebtMessage') | safe: 'html'">
                    </div>

                    <div class="message" *ngIf="getFormGroup('onBehalfOfForm')?.controls?.onBehalfOf?.value === 2"
                        [innerHtml]="getLabelValue('Authorization') | safe: 'html'">
                    </div>
                </div>

                <div class="stepper-btn-container">
                    <button matStepperNext mat-mini-fab color="primary" aria-label="Neste">
                        <mat-icon>arrow_downward</mat-icon>
                    </button>
                </div>
            </mat-step>

            <mat-step [stepControl]="caseForm.controls.youForm">

                <ng-template matStepLabel>
                    <span *ngIf="!isCorrespondentOrganization()">Opplysninger om deg</span>
                    <span *ngIf="isCorrespondentOrganization()">Opplysninger om din virksomhet</span>
                </ng-template>

                <div class="stepper-btn-container">
                    <button matStepperPrevious mat-mini-fab color="primary" aria-label="Forrige">
                        <mat-icon>arrow_upward</mat-icon>
                    </button>
                </div>

                <div formGroupName="youForm" class="form-container">
                    <div class="flex-column flex-gap-30">

                        <!-- orgnr-->
                        <app-orgnum-form-control [companyInfo]="companyInfo" *ngIf="isCorrespondentOrganization()"
                            (companyInfoReceived)="companyInfoReceived($event)" formControlName="orgNumber">
                        </app-orgnum-form-control>

                        <!-- fornavn/firma, etternavn/att-->
                        <div class="flex-row flex-gap-20">

                            <div class="flex-half">

                                <mat-form-field class="flex-grow">
                                    <mat-label>{{getAlternativePlaceholder('Fornavn', false)}}</mat-label>
                                    <input [autocomplete]="getAlternativeAutocomplete('given-name', false)"
                                        formControlName="firstName" matInput>
                                    <mat-error
                                        *ngIf="getFormGroup('youForm')?.controls?.firstName?.errors?.required">{{getAlternativePlaceholder('Fornavn',
                                        false)}} er et obligatorisk felt</mat-error>
                                    <mat-error
                                        *ngIf="getFormGroup('youForm')?.controls?.firstName?.errors?.maxlength">{{getAlternativePlaceholder('Fornavn',
                                        false)}} kan maksimalt inneholde
                                        {{getFormGroup('youForm')?.controls?.firstName?.errors?.maxlength.requiredLength}}
                                        tegn</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="flex-half">
                                <mat-form-field class="flex-grow">
                                    <mat-label>{{getAlternativePlaceholder('Etternavn', false)}}</mat-label>
                                    <input matInput formControlName="lastName"
                                        [autocomplete]="getAlternativeAutocomplete('family-name', false)">
                                    <mat-error
                                        *ngIf="getFormGroup('youForm')?.controls?.lastName?.errors?.required">{{getAlternativePlaceholder('Etternavn',
                                        false)}} er et obligatorisk felt</mat-error>
                                    <mat-error
                                        *ngIf="getFormGroup('youForm')?.controls?.lastName?.errors?.maxlength">{{getAlternativePlaceholder('Etternavn',
                                        false)}} kan maksimalt inneholde
                                        {{getFormGroup('youForm')?.controls?.lastName?.errors?.maxlength.requiredLength}}
                                        tegn</mat-error>
                                </mat-form-field>
                            </div>

                        </div>

                        <!-- Adresseinformasjon/Kontaktinformasjon -->
                        <div class="flex-row flex-gap-20">

                            <div class="flex-column flex-half flex-gap-10">
                                <div class="form-label">Adresseinformasjon</div>
                                <mat-form-field class="flex-grow">
                                    <mat-label>Land</mat-label>
                                    <mat-select formControlName="countryCodeAlpha2">
                                        <mat-option *ngFor="let countryCode of filteredCountries | async"
                                            [value]="countryCode.cca2">
                                            {{countryCode.name.common}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field class="flex-grow"
                                    *ngIf="getFormGroup('youForm')?.controls?.countryCodeAlpha2?.value !== 'NO'">
                                    <mat-label>Utenlandsk adresse</mat-label>
                                    <textarea style="height:107px;" matInput formControlName="address"></textarea>
                                    <mat-error
                                        *ngIf="getFormGroup('youForm')?.controls?.address?.errors?.maxlength">Adresse
                                        kan maksimalt inneholde
                                        {{getFormGroup('youForm')?.controls?.address?.errors?.maxlength.requiredLength}}
                                        tegn</mat-error>
                                </mat-form-field>

                                <mat-form-field class="flex-grow"
                                    *ngIf="getFormGroup('youForm')?.controls?.countryCodeAlpha2?.value === 'NO'">
                                    <mat-label>Adresse</mat-label>
                                    <input matInput formControlName="address" autocomplete="street-address">
                                    <mat-error
                                        *ngIf="getFormGroup('youForm')?.controls?.address?.errors?.required">Adresse
                                        er et obligatorisk felt</mat-error>
                                    <mat-error
                                        *ngIf="getFormGroup('youForm')?.controls?.address?.errors?.maxlength">Adresse
                                        kan maksimalt inneholde
                                        {{getFormGroup('youForm')?.controls?.address?.errors?.maxlength.requiredLength}}
                                        tegn</mat-error>
                                </mat-form-field>

                                <div class="flex-column">
                                    <div class="flex-row flex-gap-10"
                                        *ngIf="getFormGroup('youForm')?.controls?.countryCodeAlpha2?.value === 'NO'">
                                        <mat-form-field style="flex: 0 1 100px" subscriptSizing="dynamic">
                                            <mat-label>Postnr</mat-label>
                                            <input matInput formControlName="zipCode" maxlength="4"
                                                autocomplete="postal-code">
                                        </mat-form-field>

                                        <mat-form-field class="flex-grow" subscriptSizing="dynamic">
                                            <mat-label>Poststed</mat-label>
                                            <input matInput formControlName="zipArea">
                                        </mat-form-field>
                                    </div>
                                    <div class="error-text-wrapper">
                                        <mat-error *ngIf="getFormGroup('youForm')?.controls?.zipCode?.errors?.required">
                                            Postnr er
                                            obligatorisk</mat-error>
                                        <mat-error
                                            *ngIf="getFormGroup('youForm')?.controls?.zipCode?.errors?.invalidPostalCode">
                                            Ugyldig
                                            postnr</mat-error>
                                    </div>
                                </div>

                            </div>

                            <div class="flex-column flex-half flex-gap-10">
                                <div class="form-label">Kontaktinformasjon</div>

                                <div class="flex-row flex-gap-10">

                                    <mat-form-field style="flex: 0 1 180px">
                                        <mat-label>Landkode</mat-label>
                                        <mat-select formControlName="telephoneCountryCodeAlpha2">
                                            <mat-select-trigger>
                                                {{getPhoneDisplayValueFromCountryCode(getFormGroup('youForm')?.controls?.telephoneCountryCodeAlpha2?.value,
                                                false)}}
                                            </mat-select-trigger>
                                            <mat-option *ngFor="let country of filteredCountries | async"
                                                [value]="country.cca2">
                                                {{getPhoneDisplayValueFromCountryCode(country.cca2, true)}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow">
                                        <mat-label>Telefon/mobil</mat-label>
                                        <input matInput formControlName="telephone" autocomplete="tel">
                                        <mat-error
                                            *ngIf="getFormGroup('youForm')?.controls?.telephone?.errors?.required">
                                            Telefonnummer er et obligatorisk felt
                                        </mat-error>
                                        <mat-error
                                            *ngIf="getFormGroup('youForm')?.controls?.telephone?.errors?.phoneFormatError">
                                            Ugyldig telefonnummer
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <mat-form-field class="flex-grow">
                                    <mat-label>E-post</mat-label>
                                    <input matInput formControlName="email" autocomplete="email">
                                    <mat-hint>Hvis du ønsker å registrere flere e-postadresser bruker du komma som
                                        skilletegn</mat-hint>
                                </mat-form-field>

                                <div class="error-text-wrapper">
                                    <mat-error
                                        *ngIf="getFormGroup('youForm')?.controls?.email?.errors && getFormGroup('youForm')?.controls?.email?.errors?.required">
                                        E-post er et obligatorisk felt</mat-error>
                                    <mat-error *ngIf="getFormGroup('youForm')?.controls?.email?.errors && getFormGroup('youForm')?.controls?.email?.errors?.maxlength && 
                                    !getFormGroup('youForm')?.controls?.email?.errors?.required">E-post kan
                                        maksimalt inneholde
                                        {{getFormGroup('youForm')?.controls?.email?.errors?.maxlength.requiredLength}}
                                        tegn</mat-error>

                                    <mat-error
                                        *ngIf="getFormGroup('youForm')?.controls?.email?.errors && getFormGroup('youForm')?.controls?.email?.errors?.invalidEmailList">
                                        En eller flere e-postadresser er ugyldig
                                    </mat-error>

                                    <mat-error *ngIf="getFormGroup('youForm')?.controls?.email?.errors && getFormGroup('youForm')?.controls?.email?.errors?.invalidCompareEmail && 
                                    !getFormGroup('youForm')?.controls?.email?.errors?.required && 
                                    !getFormGroup('youForm')?.controls?.email?.errors?.maxlength &&
                                    !getFormGroup('youForm')?.controls?.email?.errors?.email">
                                        E-post og bekreft e-post er ikke like
                                    </mat-error>
                                </div>

                                <mat-form-field class="flex-grow">
                                    <mat-label>Bekreft e-post</mat-label>
                                    <input matInput formControlName="confirmEmail" autocomplete="none"
                                        (paste)="(false)">
                                    <mat-error
                                        *ngIf="getFormGroup('youForm')?.controls?.confirmEmail?.errors && getFormGroup('youForm')?.controls?.confirmEmail?.errors?.required">
                                        Bekreft e-post er et obligatorisk felt</mat-error>
                                </mat-form-field>

                                <mat-form-field>
                                    <mat-label>Din referanse</mat-label>
                                    <input matInput formControlName="reference" autocomplete="off">
                                </mat-form-field>

                            </div>
                        </div>

                    </div>
                </div>

                <div class="stepper-btn-container">
                    <button matStepperNext mat-mini-fab color="primary" aria-label="Neste">
                        <mat-icon>arrow_downward</mat-icon>
                    </button>
                </div>
            </mat-step>

            <mat-step [stepControl]="caseForm.controls.complainerForm" *ngIf="complainerHasCorrespondent()">

                <ng-template matStepLabel>Opplysninger om den du klager på vegne av</ng-template>

                <div class="stepper-btn-container">
                    <button matStepperPrevious mat-mini-fab color="primary" aria-label="Forrige">
                        <mat-icon>arrow_upward</mat-icon>
                    </button>
                </div>

                <div formGroupName="complainerForm" class="form-container">


                    <div class="flex-column flex-gap-30">

                        <mat-radio-group class="flex-column" formControlName="complainerIsCompany">
                            <mat-radio-button [value]="1">Klager er forbruker</mat-radio-button>
                            <mat-radio-button [disabled]="complaintType < 2" [value]="2">Klager er firma
                            </mat-radio-button>
                        </mat-radio-group>

                        <!-- orgnr-->
                        <div class="flex-row"
                            *ngIf="getFormGroup('complainerForm')?.controls?.complainerIsCompany?.value === 2">
                            <app-orgnum-form-control class="flex-half" [companyInfo]="complainerCompanyInfo"
                                (companyInfoReceived)="complainerCompanyInfoReceived($event)"
                                formControlName="orgNumber">
                            </app-orgnum-form-control>
                        </div>

                        <div class="flex-row" *ngIf="getFormGroup('complainerForm')?.controls?.complainerIsCompany?.value === 1 
                            && (getFormGroup('onBehalfOfForm')?.controls?.onBehalfOf?.value === 2 
                            || getFormGroup('onBehalfOfForm')?.controls?.onBehalfOf?.value === 3)">

                            <mat-form-field class="flex-half">
                                <mat-label>Fødselsnummer</mat-label>
                                <input matInput autocomplete="off" formControlName="pnr" matInput />
                                <mat-hint>Norsk fødselsnr/d-nummer (11 siffer), svensk personnr (ÅÅÅÅDDMMNNNN) eller
                                    dansk CPR-nr (DDMMÅÅNNNN)</mat-hint>
                                <mat-error *ngIf="getFormGroup('complainerForm')?.controls?.pnr?.errors?.SSN">Ugyldig
                                    fødselsnummer</mat-error>
                            </mat-form-field>
                            <p class="form-text">
                                <small class="text-muted">
                                    Vi ber om at du som er kontaktperson legger inn klagers fødselsnummer. Dette kreves
                                    for å aktivere lesetilgang for klager i Min sak.
                                    Denne tilgangen kan ikke gis til andre enn klager.
                                    Fødselsnummeret blir kryptert, og er ikke lesbart for Finansklagenemnda.
                                </small>
                            </p>
                        </div>

                        <!-- fornavn/firma, etternavn/att-->
                        <div class="flex-row flex-gap-20">
                            <div class="flex-half">

                                <!-- fornavn/firma -->
                                <mat-form-field class="flex-grow">
                                    <mat-label>{{getAlternativePlaceholder('Fornavn', true)}}</mat-label>
                                    <input matInput formControlName="firstName"
                                        [autocomplete]="getAlternativeAutocomplete('given-name', true)">
                                    <mat-error
                                        *ngIf="getFormGroup('complainerForm')?.controls?.firstName?.errors?.required">{{getAlternativePlaceholder('Fornavn',
                                        true)}} er et obligatorisk felt</mat-error>
                                    <mat-error
                                        *ngIf="getFormGroup('complainerForm')?.controls?.firstName?.errors?.maxlength">{{getAlternativePlaceholder('Fornavn',
                                        true)}} kan maksimalt inneholde
                                        {{getFormGroup('complainerForm')?.controls?.firstName?.errors?.maxlength.requiredLength}}
                                        tegn</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="flex-half">
                                <!-- etternavn/att -->
                                <mat-form-field class="flex-grow">
                                    <mat-label>{{getAlternativePlaceholder('Etternavn', true)}}</mat-label>
                                    <input matInput formControlName="lastName"
                                        [autocomplete]="getAlternativeAutocomplete('family-name', true)">
                                    <mat-error
                                        *ngIf="getFormGroup('complainerForm')?.controls?.lastName?.errors?.required">{{getAlternativePlaceholder('Etternavn',
                                        true)}} er et obligatorisk felt </mat-error>
                                    <mat-error
                                        *ngIf="getFormGroup('complainerForm')?.controls?.lastName?.errors?.maxlength">{{getAlternativePlaceholder('Etternavn',
                                        true)}} kan maksimalt inneholde
                                        {{getFormGroup('complainerForm')?.controls?.lastName?.errors?.maxlength.requiredLength}}
                                        tegn</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Adresseinformasjon/Kontaktinformasjon -->
                        <div class="flex-row flex-gap-20">
                            <div class="flex-column flex-half flex-gap-10">
                                <div class="form-label">Adresseinformasjon</div>

                                <mat-form-field class="flex-grow">
                                    <mat-label>Land</mat-label>
                                    <mat-select formControlName="countryCodeAlpha2">
                                        <mat-option *ngFor="let countryCode of filteredCountries | async"
                                            [value]="countryCode.cca2">
                                            {{countryCode.name.common}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field class="flex-grow"
                                    *ngIf="getFormGroup('complainerForm')?.controls?.countryCodeAlpha2?.value !== 'NO'">
                                    <mat-label>Utenlandsk adresse</mat-label>
                                    <textarea style="height:107px;" matInput formControlName="address"></textarea>
                                    <mat-error
                                        *ngIf="getFormGroup('complainerForm')?.controls?.address?.errors?.maxlength">Adresse
                                        kan maksimalt inneholde
                                        {{getFormGroup('complainerForm')?.controls?.address?.errors?.maxlength.requiredLength}}
                                        tegn</mat-error>
                                </mat-form-field>

                                <mat-form-field class="flex-grow"
                                    *ngIf="getFormGroup('complainerForm')?.controls?.countryCodeAlpha2?.value === 'NO'">
                                    <mat-label>Adresse</mat-label>
                                    <input matInput formControlName="address" autocomplete="street-address">
                                    <mat-error
                                        *ngIf="getFormGroup('complainerForm')?.controls?.address?.errors?.maxlength">Adresse
                                        kan maksimalt inneholde
                                        {{getFormGroup('complainerForm')?.controls?.address?.errors?.maxlength.requiredLength}}
                                        tegn</mat-error>

                                </mat-form-field>

                                <div class="flex-column">

                                    <div class="flex-row flex-gap-10"
                                        *ngIf="getFormGroup('complainerForm')?.controls?.countryCodeAlpha2?.value === 'NO'">
                                        <mat-form-field style="flex: 0 1 100px;" subscriptSizing="dynamic">
                                            <mat-label>Postnr</mat-label>
                                            <input matInput formControlName="zipCode" maxlength="4"
                                                autocomplete="postal-code">
                                        </mat-form-field>

                                        <mat-form-field class="flex-grow" subscriptSizing="dynamic">
                                            <mat-label>Poststed</mat-label>
                                            <input matInput formControlName="zipArea">
                                        </mat-form-field>
                                    </div>

                                    <div class="error-text-wrapper">
                                        <mat-error
                                            *ngIf="getFormGroup('complainerForm')?.controls?.zipCode?.errors?.required">
                                            Postnr er
                                            obligatorisk</mat-error>
                                        <mat-error
                                            *ngIf="getFormGroup('complainerForm')?.controls?.zipCode?.errors?.invalidPostalCode">
                                            Ugyldig
                                            postnr</mat-error>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-column flex-half flex-gap-10">
                                <div class="form-label">Kontaktinformasjon</div>

                                <div class="flex-column">
                                    <div class="flex-row flex-gap-10">
                                        <mat-form-field subscriptSizing="dynamic" style="flex: 0 1 180px;">
                                            <mat-label>Landkode</mat-label>
                                            <mat-select formControlName="telephoneCountryCodeAlpha2">
                                                <mat-select-trigger>
                                                    {{getPhoneDisplayValueFromCountryCode(getFormGroup('complainerForm')?.controls?.telephoneCountryCodeAlpha2?.value,
                                                    false)}}
                                                </mat-select-trigger>
                                                <mat-option *ngFor="let country of filteredCountries | async"
                                                    [value]="country.cca2">
                                                    {{getPhoneDisplayValueFromCountryCode(country.cca2, true)}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field subscriptSizing="dynamic" class="flex-grow">
                                            <mat-label>Klagers telefonnummer</mat-label>
                                            <input matInput formControlName="telephone" autocomplete="tel">
                                        </mat-form-field>
                                    </div>
                                    <div class="flex-row error-text-wrapper">
                                        <mat-error
                                            *ngIf="getFormGroup('complainerForm')?.controls?.telephone?.errors?.phoneFormatError">
                                            Ugyldig telefonnummer
                                        </mat-error>
                                        <mat-error
                                            *ngIf="getFormGroup('complainerForm')?.controls?.telephone?.errors?.required">
                                            Klagers telefonnummer er et obligatorisk felt
                                        </mat-error>
                                        <mat-error
                                            *ngIf="getFormGroup('complainerForm')?.controls?.telephone?.errors?.valueEquality">
                                            Klagers telefonnummer kan ikke være det samme som du har registrert på
                                            deg selv.
                                        </mat-error>
                                    </div>
                                </div>

                                <mat-form-field class="flex-grow">
                                    <mat-label>Klagers e-post</mat-label>
                                    <input matInput formControlName="email" autocomplete="email">
                                    <mat-hint>Hvis du ønsker å registrere flere e-postadresser bruker du komma som
                                        skilletegn</mat-hint>
                                </mat-form-field>

                                <div class="error-text-wrapper">
                                    <mat-error
                                        *ngIf="getFormGroup('complainerForm')?.controls?.email?.errors?.required">
                                        Klagers e-postadresse er et obligatorisk felt</mat-error>
                                    <mat-error
                                        *ngIf="getFormGroup('complainerForm')?.controls?.email?.errors && getFormGroup('complainerForm')?.controls?.email?.errors?.invalidEmailList">
                                        En eller flere e-postadresser er ugyldig
                                    </mat-error>
                                    <mat-error
                                        *ngIf="getFormGroup('complainerForm')?.controls?.email?.errors?.maxlength">E-post
                                        kan maksimalt inneholde
                                        {{getFormGroup('complainerForm')?.controls?.email?.errors?.maxlength.requiredLength}}
                                        tegn</mat-error>
                                    <mat-error
                                        *ngIf="getFormGroup('complainerForm')?.controls?.email?.errors?.valueEquality">
                                        E-postadressen til klager kan ikke være den samme som du har registrert på deg
                                        selv.
                                    </mat-error>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="stepper-btn-container">
                    <button matStepperNext mat-mini-fab color="primary" aria-label="Neste">
                        <mat-icon>arrow_downward</mat-icon>
                    </button>
                </div>

            </mat-step>

            <mat-step [stepControl]="caseForm.controls.companyForm">

                <ng-template matStepLabel>Opplysninger om
                    <span *ngIf="complaintType != 1">finansforetaket</span>
                    <span *ngIf="complaintType == 1">inkassoselskapet</span>
                    det klages på
                </ng-template>

                <div class="stepper-btn-container">
                    <button matStepperPrevious mat-mini-fab color="primary" aria-label="Neste">
                        <mat-icon>arrow_upward</mat-icon>
                    </button>
                </div>

                <div formGroupName="companyForm" class="form-container">
                    <div class="flex-column flex-gap-30">
                        <div class="flex-row flex-gap-20">
                            <div class="flex-half">
                                <mat-form-field class="flex-grow"
                                    [matTooltip]="'Velg foretak fra listen eller skriv navnet i neste felt dersom du ikke finner det i listen.'">
                                    <mat-label>Navn på finansforetaket</mat-label>
                                    <mat-select formControlName="selectedCompany">
                                        <mat-option [value]="-1">Velg fra listen</mat-option>
                                        <mat-option *ngFor="let company of companies$ | async" [value]="company">
                                            {{company.CompanyName}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error>Opplysninger om foretak er obligatorisk, du må enten velge navn i listen
                                        over
                                        eller skrive inn navnet i neste felt</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="flex-half">
                                <mat-form-field class="flex-grow">
                                    <mat-label>Navn på finansforetak når det ikke vises i listen</mat-label>
                                    <input matInput formControlName="otherCompanyName">
                                    <mat-error>Navn på finansforetak kan maksimalt inneholde 50 tegn</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="flex-row flex-gap-20">
                            <div class="flex-half">
                                <mat-form-field class="flex-grow">
                                    <mat-label>Skadenr/referanse</mat-label>
                                    <input matInput formControlName="companyCaseRef">
                                    <mat-error
                                        *ngIf="getFormGroup('companyForm')?.controls?.companyCaseRef?.errors && getFormGroup('companyForm')?.controls?.companyCaseRef?.errors?.required">Skadenr/referanse
                                        er et obligatorisk felt</mat-error>
                                    <mat-error
                                        *ngIf="getFormGroup('companyForm')?.controls?.companyCaseRef?.errors && getFormGroup('companyForm')?.controls?.companyCaseRef?.errors?.maxlength">Skadenr/referanse
                                        kan maksimalt inneholde 50 tegn</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="flex-half">
                                <mat-form-field class="flex-grow">
                                    <mat-label>Kontaktperson i foretaket</mat-label>
                                    <input matInput formControlName="contactPersonCompany">
                                    <mat-error>Kontaktperson i foretaket kan maksimalt inneholde 50 tegn</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="stepper-btn-container">
                    <button matStepperNext mat-mini-fab color="primary" aria-label="Neste">
                        <mat-icon>arrow_downward</mat-icon>
                    </button>
                </div>
            </mat-step>

            <mat-step [stepControl]="caseForm.controls.descriptionForm">

                <ng-template matStepLabel>Klagen</ng-template>

                <div class="stepper-btn-container">
                    <button matStepperPrevious mat-mini-fab color="primary" aria-label="Neste">
                        <mat-icon>arrow_upward</mat-icon>
                    </button>
                </div>

                <div formGroupName="descriptionForm" class="flex-column form-container">

                    <mat-form-field class="flex-grow">
                        <mat-label>Beskrivelse av klagen</mat-label>
                        <textarea #description matInput rows="6" formControlName="letterContent"></textarea>
                        <mat-hint align="end">{{description.value.length || 0}} av 3000 tegn</mat-hint>
                        <mat-error
                            *ngIf="getFormGroup('descriptionForm')?.controls?.letterContent?.errors && getFormGroup('descriptionForm')?.controls?.letterContent?.errors?.maxlength">Beskrivelse
                            kan maksimalt inneholde 3000 tegn</mat-error>
                    </mat-form-field>

                    <div class="helper-text captcha-error">
                        <div>Vi ber deg konkretisere klagen, gi en begrunnelse for hva du mener er gjort feil og hva du
                            ønsker å oppnå med klagen</div>
                        <div *ngIf="complaintType === 1"><b>MERK:</b> Du må også legge ved all skriftlig korrespondanse
                            mellom deg og foretaket i anledning tvisten. Rutinemessig undersøker vi at inkassovarsel og
                            betalingsoppfordring er i samsvar med gjeldende regelverk. Er det feil i varslene,
                            bortfaller plikten din til å betale inkassoomkostningene. Vi ber deg derfor vedlegge kopi av
                            disse dokumentene, se felt under.</div>
                        <div *ngIf="complaintType === 0"><b>MERK:</b> Du må også legge ved all skriftlig korrespondanse
                            mellom deg og foretaket i anledning tvisten, se felt under.</div>
                    </div>

                </div>

                <div class="stepper-btn-container">
                    <button matStepperNext mat-mini-fab color="primary" aria-label="Neste">
                        <mat-icon>arrow_downward</mat-icon>
                    </button>
                </div>
            </mat-step>

            <mat-step>

                <div class="dragpanel" class="flex-column" appDnd (fileDropped)="onFileDropped($event)">
                    <ng-template matStepLabel>Legg ved dokumenter</ng-template>

                    <div class="stepper-btn-container">
                        <button matStepperPrevious mat-mini-fab color="primary" aria-label="Neste">
                            <mat-icon>arrow_upward</mat-icon>
                        </button>
                    </div>

                    <div class="form-container">
                        <app-file-upload></app-file-upload>
                    </div>

                    <div class="stepper-btn-container">
                        <button matStepperNext mat-mini-fab color="primary" aria-label="Neste">
                            <mat-icon>arrow_downward</mat-icon>
                        </button>
                    </div>
                </div>

            </mat-step>

            <mat-step>
                <ng-template matStepLabel>Se over</ng-template>

                <div class="stepper-btn-container">
                    <button matStepperPrevious mat-mini-fab color="primary" aria-label="Neste">
                        <mat-icon>arrow_upward</mat-icon>
                    </button>
                </div>

                <div class="flex-column flex-gap-20">

                    <h1>Dine opplysninger</h1>

                    <!-- Opplysninger om deg -->
                    <div class="flex-column">
                        <h2>Opplysninger om deg</h2>
                        <h3 *ngIf="getFormGroup('onBehalfOfForm')?.controls?.onBehalfOf?.value === 1">Jeg klager på egne
                            vegne</h3>
                        <h3 *ngIf="getFormGroup('onBehalfOfForm')?.controls?.onBehalfOf?.value === 2">Jeg klager på
                            vegne av en annen</h3>
                        <h3 *ngIf="getFormGroup('onBehalfOfForm')?.controls?.onBehalfOf?.value === 3">Jeg er
                            advokat/rettshjelper e.l., og representerer en klient</h3>
                        <h3 *ngIf="getFormGroup('onBehalfOfForm')?.controls?.onBehalfOf?.value === 4">Jeg klager i
                            næringsvirksomhet</h3>

                        <div class="flex-row flex-gap-20">
                            <div class="flex-column flex-half flex-gap-10">
                                <div *ngIf="!isCorrespondentOrganization()">
                                    <p class="mat-body-strong display">Navn</p>
                                    <p class="mat-body display">
                                        {{getFormGroup('youForm')?.controls?.firstName?.value}}&nbsp;{{getFormGroup('youForm')?.controls?.lastName?.value}}
                                    </p>
                                </div>
                                <div *ngIf="isCorrespondentOrganization()">
                                    <p class="mat-body-strong display">Firma</p>
                                    <p class="mat-body display">{{getFormGroup('youForm')?.controls?.firstName?.value}}
                                    </p>
                                    <p *ngIf="getFormGroup('youForm')?.controls?.orgNumber?.value">
                                        Orgnr:{{getFormGroup('youForm')?.controls?.orgNumber?.value}}</p>
                                    <p *ngIf="getFormGroup('youForm')?.controls?.lastName?.value">
                                        Att:{{getFormGroup('youForm')?.controls?.lastName?.value}}</p>
                                </div>
                                <div>
                                    <p class="mat-body-strong display">E-post</p>
                                    <p class="mat-body display">{{getFormGroup('youForm')?.controls?.email?.value}}
                                    </p>
                                </div>
                                <div *ngIf="getFormGroup('youForm')?.controls?.telephone?.value">
                                    <p class="mat-body-strong display">Telefon</p>
                                    <p class="mat-body display">
                                        {{getPhoneDisplayValueFromCountryCode(getFormGroup('youForm')?.controls?.telephoneCountryCodeAlpha2?.value,
                                        false)}}&nbsp;{{getFormGroup('youForm')?.controls?.telephone?.value}}</p>
                                </div>

                                <div *ngIf="getFormGroup('youForm')?.controls?.reference?.value">
                                    <p class="mat-body-strong display">Din referanse</p>
                                    <p class="mat-body display">
                                        {{getFormGroup('youForm')?.controls?.reference?.value}}
                                    </p>
                                </div>

                            </div>
                            <div class="flex-column flex-half">
                                <p class="mat-body-strong display">Adresse</p>
                                <p class="mat-body display"
                                    *ngFor="let addressElement of splitNewLine(getFormGroup('youForm')?.controls?.address?.value)">
                                    {{addressElement}}
                                </p>
                                <p class="mat-body display" *ngIf="getFormGroup('youForm')?.controls?.zipCode?.value">
                                    {{getFormGroup('youForm')?.controls?.zipCode?.value}}&nbsp;{{getFormGroup('youForm')?.controls?.zipArea?.value}}
                                </p>
                                <p class="mat-body display">
                                    {{getDisplayValueFromCountryCode(getFormGroup('youForm')?.controls?.countryCodeAlpha2?.value)}}
                                </p>

                            </div>
                        </div>

                    </div>

                    <!-- Opplysninger om klager -->
                    <div class="print-spacer flex-column" *ngIf="complainerHasCorrespondent()">
                        <h2>Opplysninger om klager</h2>
                        <h3 *ngIf="getFormGroup('complainerForm')?.controls?.complainerIsCompany?.value === 1">Klager er
                            forbruker</h3>
                        <h3 *ngIf="getFormGroup('complainerForm')?.controls?.complainerIsCompany?.value === 2">Klager er
                            firma</h3>

                        <div class="flex-row flex-gap-20">
                            <div class="flex-column flex-half flex-gap-10">
                                <div *ngIf="getFormGroup('complainerForm')?.controls?.complainerIsCompany?.value === 1">
                                    <p class="mat-body-strong display">Navn</p>
                                    <p class="mat-body display">
                                        {{getFormGroup('complainerForm')?.controls?.firstName?.value}}&nbsp;{{getFormGroup('complainerForm')?.controls?.lastName?.value}}
                                    </p>
                                </div>

                                <div class="flex-row"
                                    *ngIf="getFormGroup('complainerForm')?.controls?.complainerIsCompany?.value === 2">
                                    <div class="flex-column flex-half">
                                        <p class="mat-body-strong display">Firma</p>
                                        <p class="mat-body display">
                                            {{getFormGroup('complainerForm')?.controls?.firstName?.value}}</p>
                                        <p *ngIf="getFormGroup('complainerForm')?.controls?.orgNumber?.value">
                                            Orgnr:{{getFormGroup('complainerForm')?.controls?.orgNumber?.value}}</p>
                                    </div>
                                    <div class="flex-column flex-half">
                                        <p class="mat-body-strong display">Representant</p>
                                        <p class="mat-body display">
                                            {{getFormGroup('complainerForm')?.controls?.lastName?.value}}
                                        </p>
                                    </div>
                                </div>

                                <div *ngIf="getFormGroup('complainerForm')?.controls?.email?.value">
                                    <p class="mat-body-strong display">E-post</p>
                                    <p class="mat-body display">
                                        {{getFormGroup('complainerForm')?.controls?.email?.value}}
                                    </p>
                                </div>

                                <div *ngIf="getFormGroup('complainerForm')?.controls?.telephone?.value">
                                    <p class="mat-body-strong display">Telefon</p>
                                    <p class="mat-body display">
                                        {{getPhoneDisplayValueFromCountryCode(getFormGroup('complainerForm')?.controls?.telephoneCountryCodeAlpha2?.value,
                                        false)}}&nbsp;{{getFormGroup('complainerForm')?.controls?.telephone?.value}}</p>
                                </div>

                            </div>
                            <div class="flex-column flex-half">
                                <div *ngIf="getFormGroup('complainerForm')?.controls?.address?.value">
                                    <p class="mat-body-strong display">Adresse</p>
                                    <p class="mat-body display"
                                        *ngFor="let addressElement of splitNewLine(getFormGroup('complainerForm')?.controls?.address?.value)">
                                        {{addressElement}}
                                    </p>
                                    <p class="mat-body display"
                                        *ngIf="getFormGroup('complainerForm')?.controls?.zipCode?.value">
                                        {{getFormGroup('complainerForm')?.controls?.zipCode?.value}}
                                        &nbsp;{{getFormGroup('complainerForm')?.controls?.zipArea?.value}}
                                    </p>
                                    <p class="mat-body display">
                                        {{getDisplayValueFromCountryCode(getFormGroup('complainerForm')?.controls?.countryCodeAlpha2?.value)}}
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- Opplysninger om foretak -->
                    <div class="print-spacer" class="flex-column flex-gap-20">
                        <h2>Opplysninger om
                            <span *ngIf="complaintType != 1">finansforetaket</span>
                            <span *ngIf="complaintType == 1">inkassoselskapet</span>
                            det klages på
                        </h2>

                        <div class="flex-row flex-gap-20">
                            <div class="flex-half">
                                <div *ngIf="getFormGroup('companyForm')?.controls?.selectedCompany?.value !== -1">
                                    <p class="mat-body-strong display">Foretak</p>
                                    <p class="mat-body display">
                                        {{getFormGroup('companyForm')?.controls?.selectedCompany?.value.CompanyName}}
                                    </p>
                                </div>
                                <div
                                    *ngIf="getFormGroup('companyForm')?.controls?.selectedCompany?.value === -1 && getFormGroup('companyForm')?.controls?.otherCompanyName?.value !== null">
                                    <p class="mat-body-strong display">Foretak</p>
                                    <p class="mat-body display">
                                        {{getFormGroup('companyForm')?.controls?.otherCompanyName?.value}}
                                    </p>
                                </div>
                            </div>
                            <div class="flex-half flex-column"
                                *ngIf="getFormGroup('companyForm')?.controls?.contactPersonCompany?.value">
                                <p class="mat-body-strong display">Kontaktperson i foretaket</p>
                                <p class="mat-body display">
                                    {{getFormGroup('companyForm')?.controls?.contactPersonCompany?.value}}

                            </div>
                        </div>

                        <div *ngIf="getFormGroup('companyForm')?.controls?.companyCaseRef?.value">
                            <p class="mat-body-strong display">Skadenr/referanse</p>
                            <p class="mat-body display">{{getFormGroup('companyForm')?.controls?.companyCaseRef?.value}}
                            </p>
                        </div>

                    </div>

                    <!-- Opplysninger om klagen (description) -->
                    <div class="print-spacer" class="flex-column flex-gap-10">
                        <h2>Klagen</h2>
                        <p class="mat-body display"
                            *ngFor="let addressElement of splitNewLine(getFormGroup('descriptionForm')?.controls?.letterContent?.value)">
                            {{addressElement}}
                        </p>
                    </div>

                    <!-- Opplysninger om vedlagte dokumenter -->
                    <div class="print-spacer" class="flex-column flex-gap-20">
                        <h2>Vedlagte dokumenter</h2>

                        <div class="flex-column">
                            <p class="flex-row flex-gap-20" style="align-items:center;" *ngFor="let file of files">
                                <mat-icon color="primary" aria-hidden="false"
                                    aria-label="file icon">description</mat-icon>
                                <span (click)="openFile(file)" class="display-file-name">{{file.name}}</span>
                            </p>
                        </div>
                    </div>

                    <div class="flex-row">
                        <button class="finkn-btn" color="primary" mat-raised-button type="button"
                            (click)="submitForm()">Send inn</button>
                    </div>

                </div>

            </mat-step>


        </mat-stepper>

        <div id="values">
            Hvis du ser dette feltet, la det være blankt.
            <input formControlName="otherAddress" autocomplete="off" type="text" name="otherAddress" value=""
                aria-hidden="true" tabindex="-1" />
            <input formControlName="otherEmail" autocomplete="off" type="text" name="otherEmail" value=""
                aria-hidden="true" tabindex="-1" />
        </div>
    </form>

</div>